import { render, staticRenderFns } from "./AwardTypeList.vue?vue&type=template&id=f2663bd6"
import script from "./AwardTypeList.vue?vue&type=script&lang=js"
export * from "./AwardTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports